'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { ModalBase, type ModalBaseProps } from './modal-base.tsx'
import { ModalBody } from './modal-body.tsx'
import { ModalClose } from './modal-close.tsx'
import { ModalDialog } from './modal-dialog.tsx'
import { ModalFooter } from './modal-footer.tsx'
import { ModalOverline } from './modal-overline.tsx'

type ModalWithoutVariantProps = ModalBaseProps & {
  className?: string
}

type ModalProps = ModalWithoutVariantProps & {
  variant?: 'centered' | 'unpositioned'
}

const Modal = ({ variant = 'centered', ...props }: ModalProps) => {
  if (variant === 'centered') {
    return <CenteredModal {...props} />
  }

  return <UnpositionedModal {...props} />
}

const CenteredModal = ({
  children,
  className,
  ...props
}: ModalWithoutVariantProps) => {
  return (
    <ModalBase {...props}>
      <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
        <div className="relative flex flex-col items-center xl:max-w-screen-2xl m-8 max-h-full w-full">
          <div
            className={cn(
              'flex flex-col h-full w-full items-center',
              className
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export const UnpositionedModal = ({
  children,
  ...props
}: ModalWithoutVariantProps) => {
  return <ModalBase {...props}>{children}</ModalBase>
}

const ModalNamespace = Object.assign(Modal, {
  Overline: ModalOverline,
  Dialog: ModalDialog,
  Close: ModalClose,
  Footer: ModalFooter,
  Body: ModalBody,
})

export { ModalNamespace as Modal, type ModalProps }
